import { useEffect, useRef, useState } from "react";
import { getFrameJsbridge, Webview } from "./bridge/src";
import { IJsonOption } from "./bridge/src/typings";
import React from "react";

/** 判断页面入口的环境是 商城App 还是 普通的h5 入口 */
export const pageEntryEnv = (ua: string) => {

  // 商城App的webview ua 没有特殊的标识符,使用的都是 ios 或是 android 做标识
  // mino fly 有特殊的ua
  const reg = /dji-app-(ios|android)/;
  const isAppstoreWebH5 = reg.test(ua.toLocaleLowerCase());

  return {
    isWebH5: !isAppstoreWebH5,
    isAppstoreWebH5,
  }
}

/** 调用 jsbridge 与商城webview 进行通信 */
export const jsBridgeCallHandler = (name: string, data?: any, options?: IJsonOption) => {

  // return new Promise(() => {
  // setTimeout(() => {
  // return Promise.resolve(
  //   {
  //     data: {
  //       isShapedScreen: 1,
  //       shapedScreenHeadHeight: 50
  //     }
  //   }
  // )
  // }, 2000)
  // })

  // 判断是否 iOS 系统
  const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  // 默认交互方式，客户端返回的数据为字符串
  const jsBridge = isiOS ? Webview : getFrameJsbridge();

  return jsBridge.callHandler(name, data, options).then(res => {
    if (typeof res === 'string' && res) {
      return JSON.parse(res);
    }
    return res;
  });
}

/** 商场APP 场景下的初始化页面，关闭商场App WebView的header */
export const usePageInitInAppStore = () => {

  const [pageInitLoading, setPageInitLoading] = useState(true);
  const [safeAreaHeight, setSafeAreaHeight] = useState(0);

  const shapedScreenHandler = async () => {
    const { data } = await (jsBridgeCallHandler('getEquipmentMessage') as Promise<{
      data: {
        isShapedScreen: number,
        shapedScreenHeadHeight: number
      }
    }>);

    const shapedScreenHeadHeight = data?.shapedScreenHeadHeight || 0;
    if (shapedScreenHeadHeight) {
      setSafeAreaHeight(shapedScreenHeadHeight);

      // 将安全距离写入全局的 css 变量里面
      (() => {
        // 查找已有的样式元素
        let styleElement = document.getElementById('dynamic-style') as any;

        // 如果存在，移除它
        if (styleElement) {
          styleElement.parentNode.removeChild(styleElement);
        }

        // 创建新的样式元素
        styleElement = document.createElement('style');
        styleElement.id = 'dynamic-style';

        // 样式内容
        const cssContent = `
          :root {
            --safe-area-height: ${shapedScreenHeadHeight}px;
          }
          .mobileCard {
            padding-bottom: ${shapedScreenHeadHeight || 0}px !important;
          }
        `;

        styleElement.textContent = cssContent;

        // 将新的样式元素插入到文档头部
        document.head.appendChild(styleElement);

      })()

      // 适配ios下全屏展示的顶部安全距离，防止内容穿透，所以在顶部添加一个 fixed 元素
      document.body.classList.add('app-webview-header-placeholder');
      const mask = document.querySelector('#___mask') || document.createElement('div');
      const style = `background: #fff; position: fixed; top: 0px; left: 0px; width: 100%; height: ${shapedScreenHeadHeight}px; z-index: 10 `
      mask.setAttribute('style', style);
      mask.setAttribute('id', '___mask');
      document.body.appendChild(mask);

      // 为了适配ios 下全屏展示的顶部安全距离
      const pageRoot = document.querySelector('#__next');
      pageRoot?.setAttribute('style', `
        height: calc(100vh - ${shapedScreenHeadHeight * 2}px);
        min-height: initial;
      `)

    }
  }

  const timer = useRef<NodeJS.Timeout>();

  useEffect(() => {

    const ua = window.navigator.userAgent
    const { isAppstoreWebH5 } = pageEntryEnv(ua);

    if (isAppstoreWebH5) {
      timer.current = setTimeout(() => {
        setPageInitLoading(false);
      }, 3000)

      Promise.all([
        shapedScreenHandler(),
        jsBridgeCallHandler('initPage')
      ]).finally(() => {
        clearTimeout(timer.current);
        setPageInitLoading(false);
      })
    } else {
      setPageInitLoading(false);
    }
  }, []);

  return { pageInitLoading, safeAreaHeight };
}

export const SafeAreaCtx = React.createContext<{
  safeAreaHeight: number
}>({ safeAreaHeight: 0 });